import React from 'react';

const TimeSelector = ({ times, selected, setSelected }) => {

  return (
    <div className="time-selector">
      {times.map((time, index) => (
        <div className={`${selected === time ? 'time-option time-selected' : 'time-option'}`}
             key={index}
             onClick={() => setSelected(time)}>
          {time}
        </div>
      ))}
    </div>
  );
};

export default TimeSelector;
